/**
 * @desc 分配客户经理
 */
import { AssignManager } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type AssignManagerParameter = AssignManager

const method = 'PUT'
const url = '/auth/operation/member/assign'

export const assignManagerApi = (
  data?: AssignManagerParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

assignManagerApi.method = method
assignManagerApi.url = url
